import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["style"];
import React from 'react';
import { SHOW_USAGE_WARNINGS } from '@bubble-dev/build-config';
var dontUseStyle = displayName => Target => {
  if (SHOW_USAGE_WARNINGS) {
    return props => {
      var {
          style
        } = props,
        otherProps = _objectWithoutProperties(props, _excluded);
      if (style != null) {
        console.error("Warning: Passing `style` to a component (".concat(displayName, ") is not supported. Please contact the maintainers to add the feature you need. The `style` prop you set will be ignored."));
      }
      return /*#__PURE__*/React.createElement(Target, otherProps);
    };
  }
  return Target;
};

/**
 * @deprecated this HoC is outdated and will be removed with v6.0.0
 */
export default dontUseStyle;
//# sourceMappingURL=index.js.map